module.exports = __webpack_public_path__ + "img/JSD.0f330a56.png";